import type { Page } from '@/domain/model/Page';
import type { PeriodoLetivo, UpsertPeriodoLetivoCommand } from '@/domain/model/PeriodoLetivo';
import type { PeriodoLetivoGateway, ListPeriodosParams } from '@/application/port/out/PeriodoLetivoGateway';
import type {
  ListPeriodosLetivosUseCase, CreatePeriodoLetivoUseCase, UpdatePeriodoLetivoUseCase,
  MarcarVigentePeriodoUseCase, EncerrarPeriodoUseCase,
} from '@/application/port/in/PeriodoLetivoUseCase';

export class ListPeriodosLetivos implements ListPeriodosLetivosUseCase {
  constructor(private readonly g: PeriodoLetivoGateway) {}
  execute(params: ListPeriodosParams): Promise<Page<PeriodoLetivo>> { return this.g.list(params); }
}
export class CreatePeriodoLetivo implements CreatePeriodoLetivoUseCase {
  constructor(private readonly g: PeriodoLetivoGateway) {}
  execute(cmd: UpsertPeriodoLetivoCommand): Promise<PeriodoLetivo> { return this.g.create(cmd); }
}
export class UpdatePeriodoLetivo implements UpdatePeriodoLetivoUseCase {
  constructor(private readonly g: PeriodoLetivoGateway) {}
  execute(id: string, cmd: UpsertPeriodoLetivoCommand): Promise<PeriodoLetivo> { return this.g.update(id, cmd); }
}
export class MarcarVigentePeriodo implements MarcarVigentePeriodoUseCase {
  constructor(private readonly g: PeriodoLetivoGateway) {}
  execute(id: string): Promise<PeriodoLetivo> { return this.g.marcarVigente(id); }
}
export class EncerrarPeriodo implements EncerrarPeriodoUseCase {
  constructor(private readonly g: PeriodoLetivoGateway) {}
  execute(id: string): Promise<void> { return this.g.encerrar(id); }
}
